import React from 'react';
import { Icon, IconProps } from './Icon';

export const GraphIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        d="M14.6673 14.6673H3.83398C2.45327 14.6673 1.33398 13.548 1.33398 12.1673V1.33398M3.83398 7.16732L5.739 4.54792C6.47292 3.53877 7.95166 3.46637 8.78066 4.39899C9.64293 5.36905 11.1938 5.24478 11.8906 4.1498L13.4173 1.75065M3.83398 9.66732V12.1673M7.16732 7.16732V12.1673M10.5007 8.00065V12.1673M13.834 5.50065V12.1673"
        stroke="#808080"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};
